import { useContext, useEffect, useRef } from 'react'
import { CesiumViewerContext } from '../cesiumviewer/CesiumViewer'
import { CoordinateConverter } from '../../../../../util/coordinateConverter';
import {Color, Entity, CallbackProperty, Cartesian3, ArcType, Material, PolylineDashMaterialProperty} from 'cesium';
interface Props {
    pos: number[];
    azi: number;
    ele: number;
    range: number;
    size: number;
    color: number[];
}

export default function TDOA(props: Props) {
    const viewer = useContext(CesiumViewerContext);
    const converter = new CoordinateConverter();
    const entityRef = useRef<Entity>();
    useEffect(() => {
        if (!viewer) {
            return () => { }
        }
        const posArray = converter.getLine3D(props.pos, props.azi, props.ele, props.range);
        const positions = new CallbackProperty(() => {
            return Cartesian3.fromDegreesArrayHeights([
                posArray[0][0],
                posArray[0][1],
                posArray[0][2],
                posArray[1][0],
                posArray[1][1],
                posArray[1][2],
           ]);
        }, true)
        const material = Color.fromBytes(props.color[0], props.color[1], props.color[2], props.color[3]);
        const e = viewer.entities.add({
            polyline: {
                width: props.size,
                positions,
                material,
                arcType: ArcType.NONE
            }
        } as any);
        entityRef.current = e;
        return () => { viewer!.entities.remove(e) }
    }, [viewer]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        const posArray = converter.getLine3D(props.pos, props.azi, props.ele, props.range);
        (entity as any).polyline.positions.setCallback(() => {
            return Cartesian3.fromDegreesArrayHeights([
                posArray[0][0],
                posArray[0][1],
                posArray[0][2],
                posArray[1][0],
                posArray[1][1],
                posArray[1][2],
           ]);
        }, true)
    }, [props.pos]);
    
    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        (entity as any).polyline.width.setValue(props.size);
    }, [props.size]);

    useEffect(() => {
        if (!entityRef.current) {
            return;
        }
        const entity = entityRef.current;
        const material = Color.fromBytes(props.color[0], props.color[1], props.color[2], props.color[3]);
        (entity as any).polyline.material = material;
    }, [props.color]);

    return null;
}
